















































import { Component, Vue } from 'vue-property-decorator';

import FilledButton from '@/components/molecules/FilledButton/FilledButton.vue';
import Typography from '@/componentsV2/atoms/Typography/Typography.vue';

import eventBus from '@/utils/eventBus';
import segmentIo from '@/utils/segment.io';

@Component({
  components: {
    FilledButton,
    Typography
  }
})
export default class ScheduleOnboardingModal extends Vue {
  get tPrefix() {
    return 'modals.scheduleOnboadingCall';
  }

  get business() {
    return this.$store.getters['business/getBusinessInfo'].business;
  }

  onClose() {
    eventBus.$emit('closeModal');
  }

  onSchedule() {
    this.onClose();

    window.open(
      `${process.env.VUE_APP_DASHBOARD_URL}/schedule-onboarding-call`,
      '_blank'
    );
  }

  created() {
    if (!this.business.onboardingMeeting) {
      this.onClose();
      return;
    }
    segmentIo.modal('Schedule Onboarding Call');
  }
}
